<mat-card>
	<mat-card-header>
		@if (showTitle) {
			<mat-card-title>
				{{ title }}
				<button
					mat-icon-button
					class="more-button"
					[matMenuTriggerFor]="menu"
					aria-label="Toggle menu"
					data-automation-id="cards-menu-button"
				>
					<mat-icon>more_vert</mat-icon>
				</button>
				<mat-menu #menu="matMenu" xPosition="before">
					<button mat-menu-item i18n="@@cardComponent-expand" data-automation-id="cards-expand-button">Expand</button>
					<button mat-menu-item i18n="@@cardComponent-remove" data-automation-id="cards-remove-button">Remove</button>
				</mat-menu>
			</mat-card-title>
		}
	</mat-card-header>

	<mat-card-content>
		<ng-content></ng-content>
	</mat-card-content>
</mat-card>
